export const SIDEBAR_DRAWER_WIDTH = 260;
export const HEADER_HEIGHT = 80;
